module.exports = __webpack_public_path__ + "favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/favicon-16x16.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/favicon-16x16.png
// module chunks = 3